export const COMPANY_REGISTER = '@hapvida/company-info';
